<div class="modal-devicenotrecommended">
  <div class="modal-body">
    <div class="title">
      <h1>{{ 'devicenotrecommended' | translate }}</h1>
      <div class="separator"></div>
    </div>
    <p>
        {{ 'devicenotrecommendedtext' | translate }}
    </p>
  </div>
  <div class="survey-buttons">
    <button type="button" class="btn btn-secondary" (click)="close()">
      Cerrar
    </button>
  </div>
</div>
